/**
 * @fileoverview gRPC-Web generated client stub for contentversion
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.5.0
// 	protoc              v3.20.3
// source: contentversion/contentversion.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js')

var authz_annotations_pb = require('../authz/annotations_pb.js')

var google_protobuf_empty_pb = require('google-protobuf/google/protobuf/empty_pb.js')
const proto = {};
proto.contentversion = require('./contentversion_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.contentversion.ContentVersionServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.contentversion.ContentVersionServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.contentversion.PublishContentVersionRequest,
 *   !proto.contentversion.ContentVersionRecord>}
 */
const methodDescriptor_ContentVersionService_PublishContentVersion = new grpc.web.MethodDescriptor(
  '/contentversion.ContentVersionService/PublishContentVersion',
  grpc.web.MethodType.UNARY,
  proto.contentversion.PublishContentVersionRequest,
  proto.contentversion.ContentVersionRecord,
  /**
   * @param {!proto.contentversion.PublishContentVersionRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.contentversion.ContentVersionRecord.deserializeBinary
);


/**
 * @param {!proto.contentversion.PublishContentVersionRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.contentversion.ContentVersionRecord)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.contentversion.ContentVersionRecord>|undefined}
 *     The XHR Node Readable Stream
 */
proto.contentversion.ContentVersionServiceClient.prototype.publishContentVersion =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/contentversion.ContentVersionService/PublishContentVersion',
      request,
      metadata || {},
      methodDescriptor_ContentVersionService_PublishContentVersion,
      callback);
};


/**
 * @param {!proto.contentversion.PublishContentVersionRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.contentversion.ContentVersionRecord>}
 *     Promise that resolves to the response
 */
proto.contentversion.ContentVersionServicePromiseClient.prototype.publishContentVersion =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/contentversion.ContentVersionService/PublishContentVersion',
      request,
      metadata || {},
      methodDescriptor_ContentVersionService_PublishContentVersion);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.google.protobuf.Empty,
 *   !proto.contentversion.PreviewContentVersionResponse>}
 */
const methodDescriptor_ContentVersionService_PreviewContentVersion = new grpc.web.MethodDescriptor(
  '/contentversion.ContentVersionService/PreviewContentVersion',
  grpc.web.MethodType.UNARY,
  google_protobuf_empty_pb.Empty,
  proto.contentversion.PreviewContentVersionResponse,
  /**
   * @param {!proto.google.protobuf.Empty} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.contentversion.PreviewContentVersionResponse.deserializeBinary
);


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.contentversion.PreviewContentVersionResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.contentversion.PreviewContentVersionResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.contentversion.ContentVersionServiceClient.prototype.previewContentVersion =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/contentversion.ContentVersionService/PreviewContentVersion',
      request,
      metadata || {},
      methodDescriptor_ContentVersionService_PreviewContentVersion,
      callback);
};


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.contentversion.PreviewContentVersionResponse>}
 *     Promise that resolves to the response
 */
proto.contentversion.ContentVersionServicePromiseClient.prototype.previewContentVersion =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/contentversion.ContentVersionService/PreviewContentVersion',
      request,
      metadata || {},
      methodDescriptor_ContentVersionService_PreviewContentVersion);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.google.protobuf.Empty,
 *   !proto.contentversion.ListContentVersionsResponse>}
 */
const methodDescriptor_ContentVersionService_ListContentVersions = new grpc.web.MethodDescriptor(
  '/contentversion.ContentVersionService/ListContentVersions',
  grpc.web.MethodType.UNARY,
  google_protobuf_empty_pb.Empty,
  proto.contentversion.ListContentVersionsResponse,
  /**
   * @param {!proto.google.protobuf.Empty} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.contentversion.ListContentVersionsResponse.deserializeBinary
);


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.contentversion.ListContentVersionsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.contentversion.ListContentVersionsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.contentversion.ContentVersionServiceClient.prototype.listContentVersions =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/contentversion.ContentVersionService/ListContentVersions',
      request,
      metadata || {},
      methodDescriptor_ContentVersionService_ListContentVersions,
      callback);
};


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.contentversion.ListContentVersionsResponse>}
 *     Promise that resolves to the response
 */
proto.contentversion.ContentVersionServicePromiseClient.prototype.listContentVersions =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/contentversion.ContentVersionService/ListContentVersions',
      request,
      metadata || {},
      methodDescriptor_ContentVersionService_ListContentVersions);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.contentversion.GetContentVersionRequest,
 *   !proto.contentversion.ContentVersionRecord>}
 */
const methodDescriptor_ContentVersionService_GetContentVersion = new grpc.web.MethodDescriptor(
  '/contentversion.ContentVersionService/GetContentVersion',
  grpc.web.MethodType.UNARY,
  proto.contentversion.GetContentVersionRequest,
  proto.contentversion.ContentVersionRecord,
  /**
   * @param {!proto.contentversion.GetContentVersionRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.contentversion.ContentVersionRecord.deserializeBinary
);


/**
 * @param {!proto.contentversion.GetContentVersionRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.contentversion.ContentVersionRecord)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.contentversion.ContentVersionRecord>|undefined}
 *     The XHR Node Readable Stream
 */
proto.contentversion.ContentVersionServiceClient.prototype.getContentVersion =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/contentversion.ContentVersionService/GetContentVersion',
      request,
      metadata || {},
      methodDescriptor_ContentVersionService_GetContentVersion,
      callback);
};


/**
 * @param {!proto.contentversion.GetContentVersionRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.contentversion.ContentVersionRecord>}
 *     Promise that resolves to the response
 */
proto.contentversion.ContentVersionServicePromiseClient.prototype.getContentVersion =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/contentversion.ContentVersionService/GetContentVersion',
      request,
      metadata || {},
      methodDescriptor_ContentVersionService_GetContentVersion);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.google.protobuf.Empty,
 *   !proto.contentversion.ContentVersionRecord>}
 */
const methodDescriptor_ContentVersionService_GetLatestContentVersion = new grpc.web.MethodDescriptor(
  '/contentversion.ContentVersionService/GetLatestContentVersion',
  grpc.web.MethodType.UNARY,
  google_protobuf_empty_pb.Empty,
  proto.contentversion.ContentVersionRecord,
  /**
   * @param {!proto.google.protobuf.Empty} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.contentversion.ContentVersionRecord.deserializeBinary
);


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.contentversion.ContentVersionRecord)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.contentversion.ContentVersionRecord>|undefined}
 *     The XHR Node Readable Stream
 */
proto.contentversion.ContentVersionServiceClient.prototype.getLatestContentVersion =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/contentversion.ContentVersionService/GetLatestContentVersion',
      request,
      metadata || {},
      methodDescriptor_ContentVersionService_GetLatestContentVersion,
      callback);
};


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.contentversion.ContentVersionRecord>}
 *     Promise that resolves to the response
 */
proto.contentversion.ContentVersionServicePromiseClient.prototype.getLatestContentVersion =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/contentversion.ContentVersionService/GetLatestContentVersion',
      request,
      metadata || {},
      methodDescriptor_ContentVersionService_GetLatestContentVersion);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.contentversion.GetAvailableUpgradeRequest,
 *   !proto.contentversion.GetAvailableUpgradeResponse>}
 */
const methodDescriptor_ContentVersionService_GetAvailableUpgrade = new grpc.web.MethodDescriptor(
  '/contentversion.ContentVersionService/GetAvailableUpgrade',
  grpc.web.MethodType.UNARY,
  proto.contentversion.GetAvailableUpgradeRequest,
  proto.contentversion.GetAvailableUpgradeResponse,
  /**
   * @param {!proto.contentversion.GetAvailableUpgradeRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.contentversion.GetAvailableUpgradeResponse.deserializeBinary
);


/**
 * @param {!proto.contentversion.GetAvailableUpgradeRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.contentversion.GetAvailableUpgradeResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.contentversion.GetAvailableUpgradeResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.contentversion.ContentVersionServiceClient.prototype.getAvailableUpgrade =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/contentversion.ContentVersionService/GetAvailableUpgrade',
      request,
      metadata || {},
      methodDescriptor_ContentVersionService_GetAvailableUpgrade,
      callback);
};


/**
 * @param {!proto.contentversion.GetAvailableUpgradeRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.contentversion.GetAvailableUpgradeResponse>}
 *     Promise that resolves to the response
 */
proto.contentversion.ContentVersionServicePromiseClient.prototype.getAvailableUpgrade =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/contentversion.ContentVersionService/GetAvailableUpgrade',
      request,
      metadata || {},
      methodDescriptor_ContentVersionService_GetAvailableUpgrade);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.contentversion.DownloadContentVersionRequest,
 *   !proto.contentversion.DownloadContentVersionResponse>}
 */
const methodDescriptor_ContentVersionService_DownloadContentVersion = new grpc.web.MethodDescriptor(
  '/contentversion.ContentVersionService/DownloadContentVersion',
  grpc.web.MethodType.UNARY,
  proto.contentversion.DownloadContentVersionRequest,
  proto.contentversion.DownloadContentVersionResponse,
  /**
   * @param {!proto.contentversion.DownloadContentVersionRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.contentversion.DownloadContentVersionResponse.deserializeBinary
);


/**
 * @param {!proto.contentversion.DownloadContentVersionRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.contentversion.DownloadContentVersionResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.contentversion.DownloadContentVersionResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.contentversion.ContentVersionServiceClient.prototype.downloadContentVersion =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/contentversion.ContentVersionService/DownloadContentVersion',
      request,
      metadata || {},
      methodDescriptor_ContentVersionService_DownloadContentVersion,
      callback);
};


/**
 * @param {!proto.contentversion.DownloadContentVersionRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.contentversion.DownloadContentVersionResponse>}
 *     Promise that resolves to the response
 */
proto.contentversion.ContentVersionServicePromiseClient.prototype.downloadContentVersion =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/contentversion.ContentVersionService/DownloadContentVersion',
      request,
      metadata || {},
      methodDescriptor_ContentVersionService_DownloadContentVersion);
};


module.exports = proto.contentversion;

